import { z } from 'zod';
import { DocumentTypesEnum, expectType, zDocument } from './model.js';
import { zUser } from './user.js';
import { reverseKeys } from './util/reverseKeys.js';
export const AdminActionsTakenLookup = {
    pausedUser: 'Paused User',
    blockedUser: 'Blocked User',
    created: 'Created',
    deleted: 'Deleted',
    invalid: 'Invalid'
};
export const AdminActionTakenEnum = z.nativeEnum(reverseKeys(AdminActionsTakenLookup));
export const AdminActionReasonsLookup = {
    offensive: 'Offensive Content',
    spam: 'Spam'
};
export const AdminActionReasonsEnum = z.nativeEnum(reverseKeys(AdminActionReasonsLookup));
export const AdminActionReasonsFilterLookup = { ...AdminActionReasonsLookup, all: 'All' };
export const zAdminAction = zDocument.extend({
    type: z.literal('adminAction'),
    document: z.string(),
    documentType: DocumentTypesEnum,
    user: z.string(),
    reason: AdminActionReasonsEnum,
    reviewedBy: z.string(),
    actionTaken: AdminActionTakenEnum,
    description: z.string().max(10000)
});
export const zFullAdminAction = zAdminAction.omit({ user: true }).extend({
    user: zUser,
    totalReports: z.number()
});
expectType({});
expectType({});
expectType({});
expectType({});
export const EmptyAdminAction = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    document: '',
    documentType: 'post',
    user: '',
    type: 'adminAction',
    reason: 'offensive',
    reviewedBy: '',
    actionTaken: 'created',
    description: ''
};
export const AdminActionDateRangeLookup = {
    '2000': 'All time',
    '1': '24 Hours',
    '7': 'Week',
    '30': 'Month',
    '365': 'Year'
};
export const EmptyNewAdminActionFilter = {
    sortBy: 'flags',
    dateRange: [],
    actionTaken: 'created',
    documentType: 'all',
    reason: 'all',
    userid: undefined
};
export const AdminActionSortByLookup = {
    flags: 'Flags',
    date: 'Latest'
};
export const AdminActionDocumentTypeLookup = {
    all: 'All types',
    post: 'Posts',
    comment: 'Comments'
};
